import { Grid} from '@material-ui/core'
import Box from '@mui/material/Box';
import ModalState from '../../context/ModalContext/ModalState'
import ShowSchedule from './ShowSchedule'
import ShowSchedule2 from './ShowSchedule2'

const Schedule = () =>{

    return(
        <Box>
            <Box mt={3} ml={5} className="Title">
                Estructura de Equipo
            </Box>
            <Box pt={3} ml={1}>
                <Grid container direction="row">
                    <Grid xs={8} item className="Rectangle">
                        <ModalState>
                            <ShowSchedule />
                        </ModalState>
                    </Grid>
                    <Grid xs={4} item className="Rectangle">
                        <ModalState>
                            <ShowSchedule2 />
                        </ModalState>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )

}

export default Schedule